import script from "./FirstShop.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstShop.vue?vue&type=script&setup=true&lang=js"

import "./FirstShop.vue?vue&type=style&index=0&id=6f66eb65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f66eb65"]])

export default __exports__